import { getUrlParam, getLocation } from '@/utils';
const rewardsCollection = {
  PASSPORT: {
    desc: '抽奖机会',
    text: '次'
  },
  COUPON: {
    desc: '优惠券',
    text: '元'
  },
  RED_PACKET: {
    desc: '红包',
    text: '元'
  },
  VIRTUAL_CURRENCY: {
    desc: '奖励金',
    text: '元'
  },
  CURRENCY: {
    desc: '现金',
    text: '元'
  },
  ENTITY: {
    desc: '实物',
    text: '元'
  },
  MEMBER: {
    desc: '超级会员',
    text: '天'
  },
  OIL_COUPON: {
    desc: '加油卡',
    text: '元'
  },
  REWARD_PACKAGE: {
    desc: '礼包'
  }
};
export const toDayDate = function() {};
/**
 * @param {boolean} isHideLoading: 是否不加载loading动画
 * @description 返回位置对象
 * @returns { city_id, longitude, latitude }
 * @event 一个页面不能同时调用多次，建议放在本地存储
 */
export async function getLocationObj(isHideLoading = false) {
  let locationObj = {};
  let city_id = getUrlParam('city_id');
  locationObj.city_id = city_id && city_id != 0 ? city_id : null;
  if (!locationObj.city_id) {
    const isSkipWechat = getUrlParam('bl') === '8'; // 小拉暂不走微信定位
    locationObj = await getLocation(isHideLoading, isSkipWechat);
  }
  return locationObj;
}
/**
 * 分转元
 * @param {number} val 分
 * @param {number} digits
 */
export const centToYuan = function(val, digits) {
  if (typeof val !== 'number') {
    return val;
  }
  const yuan = val / 100;
  if (digits > 0) {
    return yuan.toFixed(digits);
  }
  return yuan;
};
const isRiskError = function(ret) {
  return [11017, 11018, 11019, 11038, 11039, 11020].indexOf(ret) !== -1;
};
const translateVw = function(px) {
  return `${(px / 750) * 100}vw`;
};

export function isXL() {
  return getUrlParam('bl') === '8';
}

export function getBusiness(value) {
  switch (Number(value)) {
    case 1:
      return '通用';
    case 2:
      return '搬家';
    case 3:
      return '大车';
    case 4:
      return '小车';
    case 5:
      return '零担物流';
    case 6:
      return '司机会员';
    case 7:
      return '企业货运';
    case 8:
      return '小拉';
    default:
      return '';
  }
}
export { rewardsCollection, isRiskError, translateVw };
